import { GiHamburgerMenu } from "react-icons/gi";
import DesktopNavbar from '../desktopNavbar/DesktopNavbar';
import styles from './header.module.css';
import { CiSearch } from "react-icons/ci";
import MobileOffcanvas from "../mobileOffcanvas/MobileOffcanvas";
import { useCallback, useContext, useEffect, useState } from "react";
import AppContext from "../../contexts/Appcontext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DiscountBar from "../discountBar/DiscountBar";


export default function Header() {

  const { pathname } = useLocation();
  const navigateTo = useNavigate();
  const [isShowingOffcanvas, setIsShowingOffcanvas] = useState(false);
  const { siteInfos, hasDiscount, setHasDiscount } = useContext(AppContext);
  const [searchContent, setSearchContent] = useState('');
  const [isScrolled, setIsScrolled] = useState(false);


  useEffect(() => {
    function handleScroll() {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    }
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    }
  }, []);


  function handleSearch(content) {
    if (content.trim().length) navigateTo(`/search?query=${content.trim()}`)
  }


  return (

    <header className={styles.header} style={pathname === '/' ? { position: 'fixed' } : {}}>

      {hasDiscount && pathname === '/' && !isScrolled && <DiscountBar close={() => setHasDiscount(false)} />}

      <div className={styles.header_contents} style={pathname === '/' && !isScrolled ? { backgroundColor: "transparent" } : {}}>
        <div className='d-flex align-items-center gap-5'>
          <GiHamburgerMenu className={`${styles.hamburger} d-lg-none rounded-circle`} onClick={() => setIsShowingOffcanvas(true)} />
          <Link to='/' className={`${styles.logo_container} d-none d-md-flex align-items-center gap-1 ms-3`}>
            <img className={styles.logo} style={isScrolled ? { width: '60px' } : {}} src="/assets/images/logo/logo.png" alt={siteInfos.webname} />
            <div className='d-flex flex-column justify-content-between '>
              <strong className={`${styles.title} h2`}>{siteInfos.webname}</strong>
              {!isScrolled && <p className={styles.description}>آزمایشکاهی، تحقیقاتی، سلولی و مولکولی</p>}
            </div>
          </Link>
        </div>

        <DesktopNavbar />

        <MobileOffcanvas show={isShowingOffcanvas} close={useCallback(() => setIsShowingOffcanvas(false), [])} handleSearch={handleSearch} />

        <div className={`${styles.desktopSearch_container} d-none d-md-flex align-items-center px-2 border border-light rounded-pill`}
          style={isScrolled ? { height: '45px' } : searchContent ? { backdropFilter: 'blur(5px)', } : {}}
        >
          <input className={styles.desktopSearch} type='search' placeholder="جستجوی محصولات ..." value={searchContent}
            onChange={(event) => setSearchContent(event.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") handleSearch(searchContent) }} />
          <CiSearch className={styles.desktopSearchIcon} onClick={() => handleSearch(searchContent)} />
        </div>

        <Link className='d-md-none' to='/'>
          <img className={styles.mobileLogo} src="/assets/images/logo/logo.png" alt={siteInfos.webname} />
        </Link>
      </div>

    </header >
  )
}